import { useSelector } from 'react-redux';

import { isProviderActive } from '../utils/providers';

export function useProviderIsActive(provider) {
  return useSelector(state => isProviderActive(provider, state.system.settings.providerStatuses));
}
